module.exports = __webpack_public_path__ + "static/media/cappex.aee26416.png";